// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

// 注册Vuex插件
Vue.use(Vuex)

// 创建并导出Vuex实例
export default new Vuex.Store({
  // 存储全局状态
  state: {
    message: '欢迎使用Vuex+Vue Router+Element UI',
    count: 0,
	ServerAddress:"http://173.208.144.34:8081"
  },
  // 修改状态的方法（必须通过mutations修改state）
  mutations: {
    increment(state) {
      state.count++
    },
    setMessage(state, newMsg) {
      state.message = newMsg
    }
  },
  // 异步操作（如接口请求），最终通过mutations修改state
  actions: {
    updateMessageAsync({ commit }, newMsg) {
      // 模拟异步请求
      setTimeout(() => {
        commit('setMessage', newMsg) // 提交mutation
      }, 1000)
    }
  },
  // 计算属性（类似组件的computed）
  getters: {
    doubleCount(state) {
      return state.count * 2
    }
  }
})